















































import { Component, Vue, Inject, Ref } from 'vue-property-decorator';

import { CrudService } from '@/data/services/crud.service';
import { Contatto } from '@/data/models/contatto.model';
import { Search } from '@/data/models/search.model';
import store, { State } from '@/store';
import ContattoList from '@/views/contatti/ContattoList.vue';
import CampagnaContattiFilter from './CampagnaContattiFilter.vue';
import { cloneDeep } from 'lodash';

@Component({
	components: {
		ContattoList,
		CampagnaContattiFilter,
	},
})
export default class CampagnaContattiSearch extends Vue {
	@Inject('CrudService') crudService!: CrudService<Contatto>;

	@Ref('list') list!: ContattoList;
	@Ref('filter') filter!: CampagnaContattiFilter;

	state!: State;
	genericSearch!: Search;
	selected: Contatto[] = [];

	constructor() {
		super();
		this.state = store;
	}

	mounted() {
		this.filter.search();
	}

	onSearch(event: Search) {
		this.genericSearch = cloneDeep(event);
		this.list.advancedSearch = event;
		this.list.loadContatti();
	}

	submit(onlySelected = false) {
		if (onlySelected && this.selected.length > 0) {
			this.genericSearch.addInFilter('contact.id', this.selected.map(c => c.id));
		}
		this.$emit('submit', this.genericSearch, this.list.ct);
	}

}
